import axios from 'axios';

interface ICredentials {
  URL: string;
}

export class BaseService {
  protected _credentials?: ICredentials;

  protected _prerfix: string = '';

  public setCredentials(credentials: ICredentials): void {
    this._credentials = credentials;
  }

  protected getCurrentUrl(path: string): string {
    if (this.credentials) {
      return `${this.credentials.URL}${this.prefix}${path}`;
    }

    return `${this.prefix}${path}`;
  }

  protected get credentials() {
    return this._credentials;
  }

  protected get headers(): { headers: any } {
    return {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    };
  }

  public set prefix(prefix: string | undefined) {
    this._prerfix = prefix || '';
  }

  public get prefix(): string | undefined {
    return this._prerfix;
  }

  public async get(route: string) {
    const url: string = this.getCurrentUrl(route);
    const result = await axios.get(url, this.headers);
    return result;
  }

  public async post(route: string, data: any, customHeaders = {}) {
    const url: string = this.getCurrentUrl(route);
    const result = await axios.post(url, data, {
      headers: { ...this.headers.headers, ...customHeaders },
    });
    return result;
  }

  public async put(route: string, data: any) {
    const url: string = this.getCurrentUrl(route);
    const result = await axios.put(url, data, this.headers);
    return result;
  }

  public async patch(route: string, data: any) {
    const url: string = this.getCurrentUrl(route);
    const result = await axios.patch(url, data, this.headers);
    return result;
  }

  public async remove(route: string) {
    const url: string = this.getCurrentUrl(route);
    const result = await axios.delete(url, this.headers);
    return result;
  }
}
